module.exports = __webpack_public_path__ + "static/media/icon-gear.5b3aaa65.svg";